import {
    ReactElement,
    HTMLAttributes
} from "react";
import { EmptiList } from "../../assets";
interface Props extends HTMLAttributes<HTMLElement> {
    title :string;
}


export function EmptyTable({title}: Props): ReactElement {
    return (
        <div className="empty-table">

            <img src={EmptiList} alt="هامرز" className="empty-table-img"/>
           <span className="empty-table-title">
           {title} 
           </span>
        </div>
    )
}

export default EmptyTable;